import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import IndexLogin from './indexLogin';
import IndexNoneLogin from './indexNoneLogin';

export default function Dashboard() {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('token') ? true : false);

    return (
        <>
            <Helmet>
                <title>Dược Tâm Hạnh - Trang chủ</title>
                <meta name="description" content="Dược Tâm Hạnh - Nhà phân phối dược phẩm uy tín, chất lượng. Mua thuốc online nhanh chóng, tiện lợi." />
            </Helmet>
            {isLoggedIn && (
                <IndexLogin />
            )}
            {!isLoggedIn && (
                <IndexNoneLogin />
            )}
        </>
    )
}
